import {
  DashboardAvailableDataset,
  NavigationItems,
  PropertyOverviewTabs,
} from '@/types';
import { createAction } from '@reduxjs/toolkit';
import {
  IPermitContext,
  OpenPropertyByDeckardIdActionPayload,
} from './dashboard-types';

export const setActiveDashboardNavItem = createAction<{
  navItem: NavigationItems;
}>('DASHBOARD.SET_ACTIVE_DASHBOARD_NAV_ITEM');

export const setSidebarItems = createAction<{
  items: DashboardAvailableDataset[];
}>('DASHBOARD.SET_SIDEBAR_ITEMS');

export const setDashboardReady = createAction<{
  dashboardReady: boolean;
}>('DASHBOARD.SET_DASHBOARD_READY');

export const toggleUniversalSearch = createAction<{
  isUniversalSearchActive: boolean;
}>('DASHBOARD.TOGGLE_UNIVERSAL_SEARCH');

export const setActivePropertyDetailsTab = createAction<{
  activeTab: PropertyOverviewTabs | null | undefined;
}>('DASHBOARD.SET_ACTIVE_PROPERTY_DETAILS_TAB');

export const updatePropertyDetailsTab = createAction<{
  activeTab: PropertyOverviewTabs | null | undefined;
}>('DASHBOARD.UPDATE_PROPERTY_DETAILS_TAB');

export const setLoadingText = createAction<{ loadingText: string }>(
  'DASHBOARD.SET_LOADING_TEXT'
);

export const clearPermitContextRecord = createAction<undefined>(
  'DASHBOARD.CLEAR_PERMIT_CONTEXT_RECORD'
);

export const updatePermitContextRecordItem = createAction<{
  field: keyof IPermitContext;
  value: string | null;
}>('DASHBOARD.UPDATE_PERMIT_CONTEXT_RECORD_ITEM');

export const openComplaintById = createAction<string | number | null>(
  'DASHBOARD.OPEN_COMPLAINT_BY_ID'
);
export const openPropertyByDeckardId =
  createAction<OpenPropertyByDeckardIdActionPayload>(
    'DASHBOARD.OPEN_PROPERTY_BY_DECKARD_ID'
  );
